import { PrimaryButton,TextField,Stack,Text, Label,DefaultEffects,Nav } from '@fluentui/react';
import React,{useState ,useEffect} from 'react';

function BMI()
{
    const [state,setState] = useState({tall:0,bodykg:0,age:0,bmi:0});
    useEffect(() => {
        document.title = "BMI 계산기";  
      }, []);
   
    function calcul(e)
    {
        const value = parseInt( e.target.value);
        let newState = {...state, [e.target.name]:value};
        newState.bmi = newState.bodykg / ( (newState.tall/100)*(newState.tall/100) );
        console.log(newState.bmi);
        setState(newState);
    }
    function fat(bmi)
    {
        if(30 <= bmi)
        {
            return '비만 입니다.';
        }
        if(25<=bmi && bmi<=29.9)
        {
            return '과체중 입니다.';
        }
        if(18.5<=bmi && bmi<=24.9)
        {
            return '정상 입니다.';
        }
        if(18.5 > bmi && bmi>0)
            return '저체중 입니다.'
        return '';
    }
    return(
    <Stack.Item  align='center' tokens={{  }}  >
        <Stack tokens={{maxWidth:800, }}>
            <Text variant="superLarge" block style={{marginBottom:40}}>BMI 계산(비만도 계산)</Text>
            <Text variant="large" styles={{}}>
                남/녀, 연령 구분에 따른 신체질량지수 BMI(Body Mass Index)와 비만도를 측정해 보세요
            </Text>
            <Stack horizontal tokens={{childrenGap: "10" }}  style={{marginTop:10}} wrap >
                <Stack.Item><TextField style={{}} onChange={ function(e){calcul(e);} } name='tall' placeholder='신장' label='신장' suffix="cm"/></Stack.Item>
                <Stack.Item><TextField name='bodykg' onChange={ function(e){calcul(e);} }  placeholder='체중' label='체중' suffix="kg" /></Stack.Item>
            </Stack>
            <Text variant="superLarge" block style={{marginBottom:40}}>{`${fat(state.bmi)}`}</Text>
            <Text variant="large">{`BMI: ${state.bmi}`}</Text>
        </Stack>
    </Stack.Item>

    );
}

export default BMI;